// extracted by mini-css-extract-plugin
export default {"pageHeroWrapper":"H7nx3N","heroContent":"o0sKiE"};